export default __webpack_public_path__ + "static/media/unevenComplexion.c0222d34.svg";